import { Box, Skeleton, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { getAudioPlayer } from 'app/store/AudioPlayer/selectors';
import { LyricsResponse } from 'app/components/Playlist/ReadOnlyPlaylist/types';
import { fetchSharedResourceEffect } from 'app/store/Shares/effects';
import { getSharePlaylistGuid } from 'app/store/Shares/selectors';
import { ContentContainer } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';
import { editorTextSx } from 'app/chakra-theme/components/TextEditor';

export const AudioPlayerSharedLyrics = () => {
  const dispatch = useAppDispatch();
  const shareToken = useAppSelector(getSharePlaylistGuid);

  const [isLoading, setIsLoading] = useState(true);
  const [lyrics, setLyrics] = useState<{
    message?: string;
    audioTitle?: string;
  } | null>(null);

  const { queue, queueIndex } = useAppSelector(getAudioPlayer);
  const { audioGuid, audioTitle } = queue[queueIndex] || {};

  useEffect(() => {
    const updateByCurrentAudio = async () => {
      setIsLoading(true);
      const { lyricSheet }: LyricsResponse = await dispatch(
        fetchSharedResourceEffect({
          shareToken,
          audioGuid,
        })
      ).unwrap();
      setLyrics({
        audioTitle,
        message: lyricSheet?.body,
      });
      setIsLoading(false);
    };
    updateByCurrentAudio();
  }, [audioGuid, audioTitle, dispatch, shareToken]);

  const isEmpty = !lyrics?.message || lyrics.message === '<p></p>';

  return (
    <Box data-testid="shared-player-lyrics" pt={2}>
      <ContentContainer
        type={ContentContainerType.LIST}
        isViewContent
        pt={4}
        pb={6}
        maxWidth={640}
      >
        <Text fontSize="xxs" fontWeight={500} opacity={0.72} mb={0.5}>
          Lyrics
        </Text>
        {isLoading ? (
          <>
            <Skeleton w="50%" h={7} />
            <Skeleton h={40} my={6} />
          </>
        ) : (
          <>
            <Text fontSize="lg" fontWeight={500}>
              {lyrics?.audioTitle}
            </Text>

            {!lyrics?.message || isEmpty ? (
              <Text sx={editorTextSx} py={6} color="textSubdued">
                This song doesn&apos;t have any lyrics yet.
              </Text>
            ) : (
              <Text
                sx={editorTextSx}
                py={6}
                dangerouslySetInnerHTML={{
                  __html: lyrics.message.replaceAll('<p></p>', '</br>'),
                }}
              />
            )}
          </>
        )}
      </ContentContainer>
    </Box>
  );
};
